import { BaseField } from "./base";

export class LabelMirrorField extends BaseField {
	constructor(field, form) {
		super(field, form);
		this.sourceFieldName = this.field.dataset.sourceFieldName || null;
	}

	init() {
		const options = JSON.parse(
			this.field.dataset.labelMirrorOptions || "{}",
		);
		if (options.hide) {
			this.field.closest(".form-group").style.display = "none";
		}

		if (!this.sourceFieldName) {
			this.showError("You need to specify a source field");
			return;
		}

		this.field.readOnly = true;

		// Listen for both input and change events on the form
		this.form.addEventListener("input", (e) => this.handleSourceChange(e));
		this.form.addEventListener("change", (e) => this.handleSourceChange(e));

		// Get initial value
		this.updateValue();
	}

	handleSourceChange(e) {
		const sourceElement = this.form.querySelector(
			`[name="${this.sourceFieldName}"]`,
		);
		if (sourceElement && sourceElement === e.target) {
			this.updateValue();
		}
	}

	updateValue() {
		const sourceElement = this.form.querySelector(
			`[name="${this.sourceFieldName}"]`,
		);

		if (!sourceElement) {
			this.showError(`Source field "${this.sourceFieldName}" not found`);
			return;
		}

		if (sourceElement.tagName !== "SELECT") {
			this.showError("Source field must be a select element");
			return;
		}

		const selectedOption =
			sourceElement.options[sourceElement.selectedIndex];
		this.field.value = selectedOption ? selectedOption.text : "";
	}

	showError(msg) {
		this.field.value = `Label Mirror: ${msg}`;
		this.field.style.color = "red";
	}
}
